var mobileMenu = {
    menuContainer: document.querySelector( '#mobile-menu' ),
    toggle: document.querySelector( '#mobile-menu-toggle' ),
    clickHandler: function( event ) {
        mobileMenu.menuContainer.classList.toggle( 'open' );
        mobileMenu.toggle.classList.toggle( 'active' );
    },
    init: function() {
        mobileMenu.toggle.addEventListener( 'click', mobileMenu.clickHandler );
    }
};
mobileMenu.init();

var stickyHeader = {
    lastScrollPosition: 0,
    showHeaderPosition: 768,
    scroll: function( event ) {
        if( window.scrollY >= stickyHeader.lastScrollPosition ) {
            if( document.querySelector( 'header.sticky' ).classList.contains( 'open' ) ) {
                document.querySelector( 'header.sticky' ).classList.add( 'close' );
                document.querySelector( 'header.sticky' ).classList.remove( 'open' );
            }
            stickyHeader.lastScrollPosition = scrollY;
            return false;
        } else if( window.scrollY < stickyHeader.lastScrollPosition ) {
            if( window.scrollY > stickyHeader.showHeaderPosition && !document.querySelector( 'header.sticky' ).classList.contains( 'open' ) ) {
                document.querySelector( 'header.sticky' ).classList.add( 'open' );
                document.querySelector( 'header.sticky' ).classList.remove( 'close' );
            } else if( window.scrollY < stickyHeader.showHeaderPosition && document.querySelector( 'header.sticky' ).classList.contains( 'open' ) ) {
                document.querySelector( 'header.sticky' ).classList.remove( 'open' );
                document.querySelector( 'header.sticky' ).classList.add( 'close' );
            }
            stickyHeader.lastScrollPosition = scrollY;
            return false;
        }
    },
    init: function() {
        document.addEventListener( 'scroll', stickyHeader.scroll );
    }
};
stickyHeader.init();